var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container py-0"},[_c('v-row',{staticClass:"row"},[_c('v-col',{staticClass:"d-flex align-center",attrs:{"cols":"auto"}},[_c('router-link',{staticClass:"d-flex align-center white--text title-printers",attrs:{"to":{
          name: this.$route.params.code ? 'customer.printers' : 'home',
          params: { code: this.$route.params.code }
        }}},[_c('h1',{staticClass:"logo-printers"},[_c('strong',[_vm._v("Stavy tiskáren")])])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }